<template>
  <b-avatar-group :size="getAvatarSize(proof)">
    <b-avatar
      v-for="docType in getDocTypeAvatars(proof)"
      :key="docType.type"
      v-show="docType.show"
      :icon="docType.icon"
      :class="`avatar-color ${getProofStatusClass(proof)}`">
    </b-avatar>
  </b-avatar-group>
</template>

<script>
import { DOC_TYPES } from '../../utils/constants';
import { getProofStatusColor } from '../../utils/helpers';

export default {
  name: 'DocTypeAvatars',
  props: {
    proof: {
      type: Object,
      required: true
    },
    proofStatusColors: {
      type: Object,
      default: () => ({})
    },
  },
  methods: {
    getAvatarSize(proof) {
      let fileTypes = {};
      if (proof.docTypesUsed) {
        proof.docTypesUsed.forEach(type => fileTypes[type] = true);
      }
      return (Object.keys(fileTypes).length > 1) ? '24px' : '0px';
    },
    
    getDocTypeAvatars(proof) {
      const docTypeConfig = [
        {
          type: DOC_TYPES.WEB_URL,
          icon: 'globe',
          show: proof.docTypesUsed && proof.docTypesUsed.indexOf(DOC_TYPES.WEB_URL) >= 0
        },
        {
          type: DOC_TYPES.HTML,
          icon: 'globe',
          show: proof.docTypesUsed && proof.docTypesUsed.indexOf(DOC_TYPES.HTML) >= 0
        },
        {
          type: DOC_TYPES.IMAGE,
          icon: 'card-image',
          show: proof.docTypesUsed && proof.docTypesUsed.indexOf(DOC_TYPES.IMAGE) >= 0
        },
        {
          type: DOC_TYPES.DOCUMENT,
          icon: 'file-earmark-fill',
          show: proof.docTypesUsed && proof.docTypesUsed.indexOf(DOC_TYPES.DOCUMENT) >= 0
        },
        {
          type: DOC_TYPES.VIDEO,
          icon: 'film',
          show: proof.docTypesUsed && proof.docTypesUsed.indexOf(DOC_TYPES.VIDEO) >= 0
        },
        {
          type: DOC_TYPES.AUDIO,
          icon: 'music-note-beamed',
          show: proof.docTypesUsed && proof.docTypesUsed.indexOf(DOC_TYPES.AUDIO) >= 0
        }
      ];
      
      return docTypeConfig;
    },
    
    getProofStatusClass(proof) {
      return this.proofStatusColors[proof.id] ? this.proofStatusColors[proof.id].color : getProofStatusColor(proof.status);
    }
  }
};
</script>

<style scoped>
.avatar-color {
  color: #F9F9F9 !important;
  border: 2px solid #F9F9F9 !important;
}

::v-deep .b-avatar {
  height: 24px !important;
  width: 24px !important;
}

.status-approved {
    background-color: #019256;
}

.status-not-approved {
    background-color: #EB4654;
}

.status-waiting-for-review {
    background-color: #D9B116;
}
</style>
